export default __webpack_public_path__ + "static/media/logo.834b08ec.svg";